import api from './api'
import axios from 'axios'
import env from '@/config/env'

const baseURL = env.uploadURL
const uploadApi = axios.create({ baseURL })

async function getJWT() {
  return api.get('/admin/uploads/jwt')
}

async function send(file, onUploadProgress = () => {}) {
  const { data } = await getJWT()
  const formData = new FormData()
  formData.append('file', file)

  return uploadApi.post('/', formData, {
    headers: {
      Authorization: data.token,
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  })
}

export default { send }
